import { createContext } from 'react';
import noop from 'lodash-es/noop';

interface LayoutContextValue {
  confirm: (...args: unknown[]) => void;
  confirmDownload: (...args: unknown[]) => void;
}

export const LayoutContext = createContext<LayoutContextValue>({
  confirm: noop,
  confirmDownload: noop,
});
